import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    color?: string;
    width?: number;
    height?: number;
};

export const ChevronUpIcon = (props: Props) => {
    const { color = 'currentColor', width = 26, height = 16, ...rest } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M6.10352e-05 12.09L2.78784 15.1883L12.6028 5.61889L23.1978 15.1883L26.0001 12.09L12.6173 0L6.10352e-05 12.09Z" fill={color} />
        </svg>
    );
};
